var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0298 4.93794C23.3934 3.77199 25.6265 3.77199 27.0098 4.93794L30.1322 7.62577C30.7251 8.13958 31.8317 8.55452 32.6222 8.55452H35.9817C38.0765 8.55452 39.7958 10.2737 39.7958 12.3684V15.7281C39.7958 16.4988 40.2108 17.6253 40.7246 18.2181L43.4122 21.3404C44.5782 22.704 44.5782 24.9371 43.4122 26.3205L40.7246 29.4428C40.2108 30.0356 39.7958 31.1423 39.7958 31.9328V35.2924C39.7958 37.3872 38.0765 39.1064 35.9817 39.1064H32.6222C31.8515 39.1064 30.7251 39.5213 30.1322 40.0351L27.0098 42.7227C25.6462 43.8886 23.4132 43.8886 22.0298 42.7227L18.9075 40.0351C18.3146 39.5213 17.2079 39.1064 16.4175 39.1064H12.9986C10.9039 39.1064 9.18459 37.3872 9.18459 35.2924V31.913C9.18459 31.1423 8.76961 30.0356 8.27556 29.4428L5.60769 26.3007C4.4615 24.9371 4.4615 22.7238 5.60769 21.3602L8.27556 18.2181C8.76961 17.6253 9.18459 16.5186 9.18459 15.7479V12.3684C9.18459 10.2737 10.9039 8.55452 12.9986 8.55452H16.4175C17.1882 8.55452 18.3146 8.13958 18.9075 7.62577L22.0298 4.93794Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3301 29.3842L23.1955 31.5976C23.571 31.973 24.401 32.1509 24.9544 32.1509H28.4522C29.5589 32.1509 30.7643 31.321 31.041 30.2143L33.2543 23.4557C33.7089 22.1711 32.8789 21.0448 31.4956 21.0448H27.8001C27.2468 21.0448 26.7922 20.5904 26.8713 19.9382L27.3258 16.9739C27.5036 16.1439 26.9503 15.2151 26.1203 14.9384C25.3891 14.6617 24.4603 15.0371 24.0848 15.5905L20.2905 21.2226",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6072 29.3839V20.3331C15.6072 19.0288 16.1605 18.5742 17.4648 18.5742H18.3936C19.6781 18.5742 20.2512 19.0288 20.2512 20.3331V29.3839C20.2512 30.6684 19.6979 31.1428 18.3936 31.1428H17.4648C16.1605 31.1428 15.6072 30.6882 15.6072 29.3839Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.6450c9b67be84cdb4ed6483b9bc24f7d.svg";
export { ForwardRef as ReactComponent };